import { render } from "./brand-logo2.svg?vue&type=template&id=69ee8dc1"
const script = {}

import exportComponent from "/builds/4774/bless-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__